import { useMemo } from 'react';
import { useUrlFilters } from '@/lib/hooks/useUrlFilters';
import type { ReviewFilters } from '../types';

const defaults: ReviewFilters = {
  limit: 10,
  page: 0,
  orderBy: 'createdAt',
  order: 'desc',
  'createdAt.min': undefined,
  'createdAt.max': undefined,
  userId: undefined,
  matterId: undefined,
};

const numberFields: (keyof ReviewFilters)[] = ['limit', 'page', 'userId', 'matterId'];

export function useReviewFilters(initialFilters: Partial<ReviewFilters> = {}) {
  const mergedDefaults = useMemo(
    () => ({ ...defaults, ...initialFilters }),
    [initialFilters]
  );

  return useUrlFilters<ReviewFilters>({ defaults: mergedDefaults, numberFields });
}
